import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { isSessionExpired } from "../utils/auth/isSessionExpired.ts";
import { onLogout } from "../redux/actions/authActions.tsx";

export const useCookieWatch = () => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const checkCookie = () => {
      const isCookieExpired = isSessionExpired();

      if (!!userInfo && isCookieExpired) {
        dispatch(onLogout());
      }
    };

    checkCookie();

    const handleFocus = () => {
      checkCookie();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkCookie();
      }
    };
    const intervalId = setInterval(checkCookie, 60000);

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch, userInfo]);
};
